export type AnyFunction = (...args: any[]) => any

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const emptyFunction = () => {}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const emptyAsyncFunction = async () => {}
